import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import Link from "next/link";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";
import useJobs from "@/hooks/useJobs";

export default function OtherJobs({ job }) {
  const locale = useLocale();
  const jobs = useJobs()
    .filter((j) => j.url_slug !== job.url_slug)
    .slice(0, 5);

  return (
    <div className="bg-purple text-center h-max lg:w-[400px] py-10 px-8 font-normal 3xl:w-full 3xl:max-w-[30%]">
      <div className="text-white text-3xl">
        <CustomSourceFlowText
          title="Other roles you might be interested in:"
          path="dynamic1.otherrole.header"
          locale={locale}
        />
      </div>
      <div className="flex flex-wrap justify-center gap-7 mt-7">
        {jobs.map(({ id, title, location, description, url_slug }) => (
          <Link
            key={id}
            href={localizePath(`/jobs/${url_slug}`, locale)}
            className="w-[343px] hover:bg-green min-h-[275px] p-9 bg-white text-purple text-left flex flex-col gap-3"
          >
            <div className="flex flex-col">
              <span className="line-clamp-2 text-base/7 md:text-2xl/[34px]">
                {title}
              </span>
            </div>
            <span className="text-base">{location}</span>
            <span
              className="text-xs/[18px] line-clamp-5"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Link>
        ))}
      </div>
      <div className="flex justify-center items-center mt-11">
        <div className="text-white group w-max">
          <Link
            className="text-[white] text-xl/[25px] self-end sm:text-xl text-center pt-12 group text-decoration-none group-hover:text-blue"
            href={localizePath("/jobs", locale)}
          >
            <CustomSourceFlowText
              title="Search all jobs"
              path="dynamic1.otherrole.button"
              locale={locale}
            />
            <span className="w-0 bg-blue h-[3px] transition-all block group-hover:w-full"></span>
          </Link>
        </div>
      </div>
    </div>
  );
}
